import { ACCESO_EXTERNAL, BASE_HREF, BASE_WEB_HREF, DEFAULT_LANG, LINKS_EXTERNAL, LS_LANG, VALID_URLS } from '../../../../../core/utils/constants';
import { Utils } from 'src/app/core/utils/utils';
import { AccesoExternalService } from './../../../shared/acceso/acceso-external.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as AOS from 'aos';

@Component({
  selector: 'app-acceso-proveedor',
  templateUrl: '../../../shared/acceso/acceso-external.html',
  styleUrls: ['../../../shared/acceso/acceso-external.scss']
})
export class AccesoProveedorComponent implements OnInit {

  /** Rutas a imagenes de pagina acceso proveedor */
  readonly LOGO_AYUDA: String = BASE_HREF + '/assets/images/help-btn.svg';
  readonly IMGACCESEXTERN: string = BASE_HREF + '/assets/images/carpetaProveidor.jpg';

  /**rutas externas a webs y servicios de Reus */
  readonly REUS_SERVICIOS: String = LINKS_EXTERNAL.REUS_SERVICIOS;
  readonly REUS_REQUISITOS: String = LINKS_EXTERNAL.REUS_REQUISITOS;
  readonly REUS_REQUISITOS_GUIA: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA;
  readonly REUS_INCIDENCIAS: String = LINKS_EXTERNAL.REUS_INCIENCIAS;

  loading: boolean = false;
  public type: number = 0;

  constructor(public accesoExtService: AccesoExternalService,
              private route: ActivatedRoute,
              private translateService: TranslateService) { }

  ngOnInit() {
    console.log("acceso-proveedor.component");
    let param = this.route.snapshot.queryParams["idioma"];
    if(param == 'ca' || param == 'es'){
      this.translateService.setDefaultLang(param);
      this.translateService.use(param);
      localStorage.setItem(LS_LANG, param);
      Utils.changeStyleTranslate();
    }
    this.loading = true;
    this.accesoExtService.inicio(3).subscribe(arg => {
        this.loading = false;
    });
    AOS.init();
  }

  /**
  * @description
  * Al pulsar botón acceso; si está deshabilitado nos lleva al foco inicial
  */
  focomensaje() {
    window.scrollTo(0, 0);
  }

  /**
  * @description
  * El usuario accede a la carpeta proveedor
  */
  public acceder() {
    console.log("acceder acceso-proveedor");
    //window.location.href = this.accesoExtService.urlValid;

    this.type = Utils.noUndfAndNull(3) && 3 <= 3 && 3 >= 1 ? 3 : ACCESO_EXTERNAL.ciudadano.type;
    let object = this.type == 2 ? ACCESO_EXTERNAL.empresa : (this.type == 3 ? ACCESO_EXTERNAL.proveedor : ACCESO_EXTERNAL.ciudadano)
    console.log(object);

    let url = VALID_URLS.LOGIN;
    let urlOk = "?path_ok=" + BASE_WEB_HREF + object.urlOK;
    let urlKo = "&path_ko=" + BASE_WEB_HREF + object.urlKO;
    let urlCancel = "&path_cancel=" + BASE_WEB_HREF + object.urlCancel;
    let cliente = "&client_id=tramits.reus.cat";
    let idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    
    if(this.accesoExtService.urlValid === undefined || this.accesoExtService.urlValid === ""){
      if(idioma == 'es'){
        window.location.href = url + urlOk + urlKo + urlCancel + "&idioma=esp" + cliente;
      }else{
        window.location.href = url + urlOk + urlKo + urlCancel + cliente;
      }
    }else{
      if (this.accesoExtService.url?.value) {
        this.accesoExtService.crearUrl(this.accesoExtService.objeto, this.accesoExtService.url.value);
        window.location.href = this.accesoExtService.urlValid;
      }
    }
  }

}
